import React from 'react';
import { Backdrop, CircularProgress } from '@mui/material';
import './styles.css';

const CustomLoading = (props) => {
    const { show } = props;

    return (
        <Backdrop className="content-loader" open={show} >
            <CircularProgress
                style={{ position: 'absolute', top: '40%', left: '45%', height: '100px', width: '100px' }}
            />
        </Backdrop>
    )
}


export default CustomLoading;